import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
//
import { useTranslation } from 'react-i18next';
import { fetchPostsApi } from 'utils/clientApis';
//
import BoardCard from 'views/Peloton/Club/Menu/PostList/PostCard';
//
import { makeStyles } from '@material-ui/styles';
import { Box, Typography } from '@material-ui/core';
import Pagination from '@mui/material/Pagination';
//
import CustomCircularProgress from 'views/Peloton/Common/CustomCircularProgress';
import BoardWrite from './PostWrite';
import NoData from 'views/Peloton/Common/NoData';
import scrollToTop from 'views/Peloton/Utils/scrollToTop';

const useStyles = makeStyles(theme => ({
  root: {},
  title: {
    fontSize: '16px',
    color: '#455A64',
    fontWeight: '700',
    padding: '0px',
    [theme.breakpoints.up('md')]: {
      fontSize: '16px'
    }
  }
}));

const PostList = prop => {
  const classes = useStyles();
  const { t } = useTranslation(['page']);
  const history = useHistory();
  const location = useLocation();

  const { data } = prop;
  const pelotonId = data?.id;
  const uriName = data?.uriName;

  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(9);
  const [pageTotal, setPageTotal] = useState(1);
  const [isDataLoading, setIsDataLoading] = useState(false);

  const postsArr = Array.isArray(posts) ? posts : [posts];
  const tabChecker = JSON.parse(localStorage.getItem('tab'));
  const istabPost = tabChecker.tabName === 'post';

  const searchParams = new URLSearchParams(location.search);
  const page = parseInt(searchParams.get('page') || '1', 10);

  useEffect(() => {
    handleGetPostData();
    // 마운트 될 때
    const currentSearch = new URLSearchParams(location.search);
    if (!currentSearch.has('page')) {
      currentSearch.set('page', '1');
      history.push({
        pathname: location.pathname,
        search: currentSearch.toString()
      });
    }

    // 언마운트 될 때 cleanup
    return () => {
      const searchParams = new URLSearchParams(location.search);
      if (searchParams.has('page')) {
        searchParams.delete('page');
      }
    };
  }, []);

  const handleGetPostData = async () => {
    setIsDataLoading(true);
    try {
      if (currentPage) {
        const response = await fetchPostsApi(
          pelotonId,
          currentPage - 1,
          itemsPerPage
        );
        setPosts(response.data.response.content);
        setPageTotal(response.data.response.totalPages);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsDataLoading(false);
    }
  };

  /**
   * @return : 페이지네이션 구현부.
   */
  useEffect(() => {
    // screenRef.current.scrollIntoView({ behavior: 'auto', block: 'start' });
    // 페이지 번호가 변경될 때마다 새로운 페이지 데이터를 불러옵니다.
    handleGetPostData();
  }, [currentPage, page]);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
    if (istabPost) {
      history.push(`?page=${newPage}`);
      scrollToTop();
    }
  };

  return (
    <div className={classes.root}>
      {/* <div ref={screenRef} style={{ scrollMarginTop: '140px' }} /> */}
      {!isDataLoading ? (
        <>
          <Typography
            className={classes.title}
            style={{ marginBottom: '16px' }}>
            게시판
          </Typography>
          <BoardWrite
            handleGetPostData={handleGetPostData}
            profileImage={data.myClubUserResponse.profileImage}
          />
          {posts.length > 0 ? (
            <>
              {postsArr.map((post, idx) => {
                return (
                  <BoardCard
                    key={idx}
                    post={post}
                    idx={idx}
                    uriName={uriName}
                    clubProp={prop}
                    page={currentPage}
                  />
                );
              })}
              <Box my={2} display="flex" justifyContent="center">
                <Pagination
                  count={pageTotal}
                  page={currentPage}
                  onChange={handleChangePage}
                  shape="rounded"
                  hidePrevButton
                  hideNextButton
                />
              </Box>
            </>
          ) : (
            <NoData title="작성된 게시물이 없습니다." />
          )}
        </>
      ) : (
        <CustomCircularProgress />
      )}
    </div>
  );
};
export default PostList;
